import { Gravidanza } from '../../../@core/models/gravidanza';
import { filter } from 'rxjs/operators';
import { MacrotemaFaq, CategoriaFaq, SottoCategoriaFaq, Faq, ParolaChiave } from '@hm_app/@core/models/info';
import { AreaVasta } from '@hm_app/@core/models/anagrafica_geo';
import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash-es';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RicercaFaqComponent } from '../ricerca-faq/ricerca-faq.component';
import { GlossarioFaqComponent } from '../glossario-faq/glossario-faq.component';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { Utente } from '@hm_app/@core/models/utente';

@Component({
    selector: 'ngx-losaiche',
    templateUrl: './losaiche.component.html',
    styleUrls: ['./losaiche.component.scss'],
})
export class LosaicheComponent implements OnInit {

    user: Utente;
    gravidanza: Gravidanza;
    aree_vaste: AreaVasta[];
    _current_area: AreaVasta;
    macrotemi: MacrotemaFaq[];
    sottocategorie: SottoCategoriaFaq[];
    faqs_area: Faq[];
    all_faqs: Faq[];
    categorie: CategoriaFaq[];
    parole_chiave: ParolaChiave[];
    filtered_faqs: Faq[];

    constructor(private service: HappyMammaService, private modalService: NgbModal) { }

    set current_area(area: AreaVasta) {
        this._current_area = area;
        this.filterFaqsAree();
    }

    filterFaqsAree() {
        const current_id = this._current_area ? this._current_area.id : null;
        this.faqs_area = _.filter(this.all_faqs, function (f: Faq) {
            return (f.area_vasta == null || f.area_vasta == current_id);
        });
    }

    get current_area() {
        return this._current_area;
    }

    async ngOnInit() {
        this.aree_vaste = await this.service.areeVasteAllPromise();
        this.parole_chiave = await this.service.parole_chiaveAllPromise();


        const macrotemi = await this.service.macrotemaFaqAllPromise();
        this.macrotemi = _.sortBy(macrotemi, 'id');

        this.categorie = await this.service.categoriaFaqAllPromise();

        this.sottocategorie = await this.service.sottoCategoriaFaqAllPromise();

        this.all_faqs = await this.service.publicFaqAllPromise();

        this.current_area = null;

        this.filterFaqsAree();
    }

    onFaqFiltered(event: Faq[]) {
        this.filtered_faqs = event;
    }

    showSearch() {
        const modal = this.modalService.open(RicercaFaqComponent, { size: 'lg' });
        modal.componentInstance.faqs = this.faqs_area;
    }

    showGlossary() {
        const modal = this.modalService.open(GlossarioFaqComponent, { size: 'lg' });
        modal.componentInstance.faqs = this.faqs_area;
    }

    changeArea(area) {
        this.current_area = area;
    }

}
